import React from "react";
import { Drawer } from "@material-ui/core";
import B2BCartItem from "./B2BCartItem";
import Divider from "@material-ui/core/Divider";
import CircularProgress from "@material-ui/core/CircularProgress";
import ActionButton from "../../ActionButton";
import TotalCharge from "../TotalCharge";
import RemoveShoppingCartIcon from "@material-ui/icons/RemoveShoppingCart";
import { useSelector } from "react-redux";
import ClearIcon from "@material-ui/icons/Clear";

const B2BCart = ({
  cartDrawerOpen,
  toggleDrawer,
  cart,
  products,
  buttonLoading,
  didChoosePaymentMethod,
  didMeetMOV,
  handlePlaceOrder,
  checkbox,
  balanceCheckLoading,
  distributor,
  getSubTotal,
  getDiscountTotal,
  deliveryPrice,
  handleRemoveItemFromCart,
  handleEmptyCart,
  customTexts,
}) => {
  const language = useSelector((state) => state.store.language);
  let productsInCart = [];
  for (const item in cart) {
    if (cart[item] > 0) {
      productsInCart.push(
        products.filter((product) => +product.product.id === +item)[0]?.product
      );
    }
  }
  const placeOrderText =
    language === "english"
      ? customTexts.place_order
      : customTexts.place_order_ar;
  const addItemsText =
    language === "english" ? "Add more to cart" : "اضف المزيد من المنتجات";
  return (
    <Drawer
      anchor="bottom"
      open={cartDrawerOpen}
      PaperProps={{
        style: {
          minHeight: 100,
          height: "auto",
          width: "100%",
          marginBottom: distributor?.show_prices ? 150 : 60,
        },
        className: "text-center",
      }}
      onBackdropClick={() => toggleDrawer(false)}
    >
      <div style={{ backgroundColor: "white", height: "60vh" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            padding: 20,
          }}
        >
          <div style={{ textAlign: "left" }}>
            <ClearIcon onClick={() => toggleDrawer(false)} />
          </div>
          <p
            style={{
              fontSize: 17,
              fontWeight: "bold",
              margin: 0,
            }}
          >
            {language === "english" ? "Cart" : "السلة"}
          </p>
          <div style={{ textAlign: "right" }}>
            <RemoveShoppingCartIcon
              onClick={handleEmptyCart}
              style={{ color: "red" }}
            />
          </div>
        </div>
        <Divider />
        <div style={{ padding: 10, backgroundColor: "white" }}>
          {productsInCart.map((product) => (
            <B2BCartItem
              handleRemoveItemFromCart={handleRemoveItemFromCart}
              product={product}
              cart={cart}
              showPrice={distributor?.show_prices}
            />
          ))}
        </div>
      </div>
      {distributor?.show_prices && (
        <TotalCharge
          total={getSubTotal() + deliveryPrice}
          subtotal={getSubTotal()}
          discountTotal={getDiscountTotal()}
          deliveryPrice={deliveryPrice}
          distributor={distributor}
        />
      )}
      <ActionButton
        action={
          !buttonLoading ? (
            didMeetMOV ? (
              placeOrderText
            ) : (
              addItemsText
            )
          ) : (
            <span>
              <CircularProgress
                style={{ width: 30, height: 30, color: "white" }}
              />
            </span>
          )
        }
        b2b
        onClick={!buttonLoading ? handlePlaceOrder : () => {}}
        placeOrderButtonDisabled={
          !checkbox ||
          !didMeetMOV ||
          !didChoosePaymentMethod() ||
          balanceCheckLoading
        }
      />
    </Drawer>
  );
};

export default B2BCart;
